<template>
  <div v-if="$store.state.module">
    <div class="home">
      <div id="search_container">
        <div class="search_form">
                    <b-button class="search_button">
            <b-icon icon="search"></b-icon>
          </b-button>
          <b-form-input
            class="search_field"
            placeholder="Rechercher par dossard"
            type="number"
            v-model="searchFilter"
            @input="searchPhotos()"
            size="sm"
          ></b-form-input>

        </div>
        <p class="search_tooltip">
          A l'aide de votre dossard, nous allons identifier les photos prises
          aux alentours de votre heure d'arrivée
        </p>
      </div>
      <Gallery v-if="images.length > 0" :images="images"></Gallery>

      <div v-else class="error_galerie">
        <h2 v-if="searchFilter===''">Désolé, aucune photo n'a été trouvée...</h2>
        <h2 v-else>Désolé, aucune photo n'est disponible pour le dossard n°{{searchFilter}}...</h2>
      </div>
      <b-button v-if="moreToLoad" @click="loadMore"
        >Charger plus de photos</b-button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Gallery from "@/components/Gallery.vue";

export default {
  name: "Home",
  components: {
    Gallery,
  },
  data() {
    return {
      moreToLoad: true,
      page: 0,
      searchFilter: "",
      images: [],
      firstload: false,
    };
  },
  methods: {
    emptySearch() {
      if (this.searchFilter === "") {
        this.searchPhotos();
      }
    },
    loadMore() {
      this.page++;
      console.log("Load more");
      var _this = this;
      axios
        .get(
          this.$store.state.base_url +
            "/list_photos/get.php?module=" +
            this.$route.params.base +
            "&id_module=" +
            this.$store.state.module.id +
            "&search=" +
            this.searchFilter +
            "&page=" +
            this.page
        )
        .then(function (response) {
          _this.images = _this.images.concat(response.data);
          _this.moreToLoad = response.data.length === 100;
        });
    },
    searchPhotos() {
      console.log("search");
      var _this = this;
      if (this.searchFilter !== "") {
        this.page = 0;
      }
      axios
        .get(
          this.$store.state.base_url +
            "/list_photos/get.php?module=" +
            this.$route.params.base +
            "&id_module=" +
            this.$store.state.module.id +
            "&search=" +
            this.searchFilter +
            "&page=" +
            this.page
        )
        .then(function (response) {
          _this.images = response.data;
          _this.moreToLoad = response.data.length === 100;
        });
    },
  },
  created() {
    this.searchPhotos();
    var _this = this;
    axios
      .get(
        this.$store.state.base_url +
          "/list_photos/get.php?module=" +
          this.$route.params.base +
          "&id_module=" +
          this.$store.state.module.id
      )
      .then(function (response) {
        _this.firstload = true;
        _this.images = response.data;
      });
  },
};
</script>

<style lang="scss">
</style>



